export type SortFilterItem = {
  title: string;
  slug: string | null;
  sortKey: "RELEVANCE" | "BEST_SELLING" | "CREATED_AT" | "PRICE";
  reverse: boolean;
};

export const defaultSort: SortFilterItem = {
  title: "Relevance",
  slug: null,
  sortKey: "RELEVANCE",
  reverse: false,
};

export const sorting: SortFilterItem[] = [
  defaultSort,
  {
    title: "Trending",
    slug: "trending-desc",
    sortKey: "BEST_SELLING",
    reverse: false,
  }, // asc
  {
    title: "Latest arrivals",
    slug: "latest-desc",
    sortKey: "CREATED_AT",
    reverse: true,
  },
  {
    title: "Price: Low to high",
    slug: "price-asc",
    sortKey: "PRICE",
    reverse: false,
  }, // asc
  {
    title: "Price: High to low",
    slug: "price-desc",
    sortKey: "PRICE",
    reverse: true,
  },
];

export type TypeFilterItem = {
  title: string;
  slug: string | null;
};

export const defaultTypeFilter: TypeFilterItem = {
  title: "All",
  slug: null,
};

export const typing: TypeFilterItem[] = [
  defaultTypeFilter,
  {
    title: "Caps",
    slug: "baseball caps",
  },
  {
    title: "T-Shirts",
    slug: "t-shirts",
  },
  {
    title: "Hoodies",
    slug: "hoodies",
  },
  {
    title: "Beanies",
    slug: "beanies",
  },
  {
    title: "Mouse pads",
    slug: "mouse pads",
  },
];

export type SizeFilterItem = {
  title: string;
  slug: string | null;
};

export const defaultSizeFilter: SizeFilterItem = {
  title: "All",
  slug: null,
};

export const sizing: SizeFilterItem[] = [
  defaultSizeFilter,
  {
    title: "S",
    slug: "s",
  },
  {
    title: "M",
    slug: "m",
  },
  {
    title: "L",
    slug: "l",
  },
  {
    title: "XL",
    slug: "xl",
  },
];

export const defaultMinPrice = 1;
export const defaultMaxPrice = 999;

export const TAGS = {
  collections: "collections",
  products: "products",
  cart: "cart",
};

export const HIDDEN_PRODUCT_TAG = "nextjs-frontend-hidden";
export const DEFAULT_OPTION = "Default Title";
export const SHOPIFY_GRAPHQL_API_ENDPOINT = "/api/2026-07/graphql.json";
